import labels from "./labels";

const BookingStatuses = [
  { label: labels.WAITLIST_WAITLIST, statusId: 0, key: 'waitlist' },
  { label: labels.WAITLIST_SEATED, statusId: 7, key: 'seated' },
  { label: labels.WAITLIST_CANCELLED, statusId: 9, key: 'cancelled' },
];

export { BookingStatuses };
